import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import PropTypes from 'prop-types';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import TextField from '@material-ui/core/TextField';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Slide from '@material-ui/core/Slide';
import Typography from '@material-ui/core/Typography';

import { withStyles } from '@material-ui/core/styles';

import CloseIcon from '@material-ui/icons/Close';

import InvoiceHeader from './Preview/InvoiceHeader';
import InvoiceLineItems from './Preview/InvoiceLineItems';
import InvoiceTotals from './Preview/InvoiceTotals';

import { startSendInvoice } from '../../../store/actions/invoicePreview';
import { startEditInvoiceStatuses } from '../../../store/actions/invoices';

const styles = {
  appBar: {
    position: 'relative',
  },
  button: {
   fontSize: 12,
     '&:hover': {
       background: 'blue'
     }
  },
  flex: {
    flex: 1,
  },
  content: {
    display: 'flex',
    justifyContent: 'center',
  },
  invoice: {
    display: 'flex',
    flexDirection: 'column',
    flexBasis: '1000px',
  },
  invoiceHeader: {
  },
  invoiceBody: {
    paddingTop: '30px',
  },
  '@media (min-width: 1024px)': {
    button: {
      width: 400
    }
  },
  '@media print': {
    appBar: {
      display: 'none',
    },
    invoiceHeader: {
      display: 'none',
    },
    button: {
      color: 'green'
    },
    content: {

    }
  }
};

function Transition(props) {
  return <Slide direction="up" {...props} />;
}

//TODO: refactor into components
//TODO: use promises on send button
class InvoicePreview extends React.Component {
  constructor(props){
    super(props);

    this.state = {
      recipient: "",
    }
  }
  componentDidMount() {
    if (this.props.client !== undefined) this.setState({recipient: this.props.client.email});
  }

  render() {
    const {
      classes,
      invoice,
      client,
      business,
      showPreview,
      handleClose,
      startSendInvoice,
      startEditInvoiceStatuses
    } = this.props;

    return (
      <div className={classes.test}>
        <Dialog
          fullScreen
          open={showPreview}
          onClose={handleClose}
          transition={Transition}
        >
          <AppBar className={classes.appBar}>
            <Toolbar>
              <IconButton color="inherit" onClick={handleClose} aria-label="Close">
                <CloseIcon />
              </IconButton>
              <Typography variant="title" color="inherit" className={classes.flex}>
                Send Invoice
              </Typography>
              <Button color="inherit" onClick={() => window.print()}>
                print
              </Button>
              <Button color="inherit" onClick={
                  () => {
                      startSendInvoice({
                        invoiceID: invoice.id,
                        invoiceNumber: invoice.invoiceNumber,
                        grandTotal: invoice.grandTotal.toFixed(2),
                        balance: invoice.balance.toFixed(2),
                        recipient: this.state.recipient,
                        clientName: client.firstName + ' ' + client.lastName,
                        companyName: business.companyName
                      });
                      startEditInvoiceStatuses(invoice.id, {sent: true});
                      handleClose();
                  }
                }>
                send
              </Button>
              <Button color="inherit" onClick={handleClose}>
                done
              </Button>
            </Toolbar>
          </AppBar>
          <div className={classes.content}>
            <div className={classes.invoice}>
              <div className={classes.invoiceHeader}>
                <TextField
                  id="full-width"
                  label="To"
                  value={this.state.recipient}
                  onChange={(event) => this.setState({recipient: event.target.value})}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  placeholder="Enter email"
                  fullWidth
                  margin="normal"
                />
              </div>
              <div className={classes.invoiceBody}>
                <InvoiceHeader
                  invoice={invoice}
                  client={client}
                  business={business}
                />
              <InvoiceLineItems invoice={invoice} />
              <InvoiceTotals invoice={invoice} />
              </div>
            </div>
          </div>
        </Dialog>
      </div>
    );
  }
}

InvoicePreview.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  client: state.adminState.client,
  business: state.businessState
});

const mapDispatchToProps = (dispatch) => ({
  startSendInvoice: (payload) => dispatch(startSendInvoice(payload)),
  startEditInvoiceStatuses: (invoiceID, statuses) => dispatch(startEditInvoiceStatuses(invoiceID, statuses))
});

export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(InvoicePreview);
//withStyles(styles)(InvoicePreview);



// WEBPACK FOOTER //
// ./src/components/admin/Invoice/InvoicePreview.jsx